import {inject, Injectable} from '@angular/core';
import {PlatformService} from "./platform.service";
import {MessageService} from "primeng/api";

@Injectable({
  providedIn: 'root'
})
export class PwaService {
  private readonly platformService = inject(PlatformService);
  private readonly messageService = inject(MessageService);

  private currentHash: string | undefined;

  public async checkForUpdates() {
    if (this.platformService.isServer || typeof fetch === 'undefined') {
      return;
    }

    try {
      const response = await fetch(`/version.json?t=${Date.now()}`);

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      const fetchedHash = data.hash;

      if (!fetchedHash) {
        return;
      }

      if (this.currentHash === undefined) {
        this.currentHash = fetchedHash;
        return;
      }

      if (fetchedHash !== this.currentHash) {
        this.messageService.add({
          severity: 'info',
          summary: 'Update available',
          detail: 'New version available. Reloading...',
          sticky: true,
          closable: true,
          life: undefined,
        });

        setTimeout(() => window.location.reload(), 2000);
      }
    } catch (error) {
      console.error('Error checking for updates:', error);
    }
  }
}
